import dayjs from 'dayjs'
import { User } from '../../utils/types/authTypes'
import {
  SupportListFilters,
  SupportRequest,
  SupportRequestStatus,
} from '../types/supportTypes'

const isSupportAgent = (user: User) =>
  (user.roles as string[]).includes('ROLE_SUPPORT')

const isSupportRequestRaiser = (user: User, supportRequest: SupportRequest) =>
  supportRequest.raisedBy.id === user.id

const canWriteSupportRequest = (user: User, supportRequest: SupportRequest) =>
  isSupportAgent(user) || isSupportRequestRaiser(user, supportRequest)

const SUPPORT_STATUS_CHIP_COLOR: Record<
  SupportRequestStatus,
  'warning' | 'success' | 'default'
> = {
  awaiting_reply: 'warning',
  answered: 'success',
  closed: 'default',
}

const formatUnansweredFor = (seconds: number | null) => {
  if (seconds === null) {
    return ''
  }

  const minutes = Math.floor(seconds / 60)
  const hours = Math.floor(minutes / 60)
  const days = Math.floor(hours / 24)

  if (days > 0) {
    return `${days}d ${hours % 24}h`
  }

  if (hours > 0) {
    return `${hours}h ${minutes % 60}m`
  }

  return `${minutes}m`
}

const supportFilterStrategy = (filters: SupportListFilters) => {
  let parsedFilter = ''

  if (filters.status !== 'all') {
    parsedFilter += `&status=${filters.status}`
  }

  if (filters.date !== '0') {
    const dateParsed = dayjs().subtract(Number(filters.date), 'days')
    parsedFilter += `&lastMessageAt[gte]=${dateParsed.unix()}`
  }

  if (filters.order !== 'default') {
    const [orderField, orderDirection] = filters.order.split(',')
    parsedFilter += `&order[${orderField}]=${orderDirection}`
  }

  return parsedFilter
}

export {
  supportFilterStrategy,
  isSupportAgent,
  isSupportRequestRaiser,
  canWriteSupportRequest,
  SUPPORT_STATUS_CHIP_COLOR,
  formatUnansweredFor,
}
